export enum DynamicType {
  Text = 1,
  Image = 2,
  Video = 3,
}

export class DynamicField {
  constructor(
    public id: number,
    public name: string,
    public description: string,
    public linkType: DynamicType,
  ) {}
}
